<template>
  <Row :cols="4" customClass="stats-row">
    <BackupsStatCard :id="id" />
    <DeploymentsStatCard :id="id" />
    <CostsStatCard :id="id" />
    <AlertsStatCard :id="id" />
  </Row>
</template>

<script>
import Row from './Row.vue'
import BackupsStatCard from '../Cards/StatCards/BackupsStatCard.vue'
import DeploymentsStatCard from '../Cards/StatCards/DeploymentsStatCard.vue'
import CostsStatCard from '../Cards/StatCards/CostsStatCard.vue'
import AlertsStatCard from '../Cards/StatCards/AlertsStatCard.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'StatsRow',
  components: {
    Row,
    BackupsStatCard,
    DeploymentsStatCard,
    CostsStatCard,
    AlertsStatCard
  },
  props: {
    id: {
      type: String,
      required: false,
      default: 'AllContracts'
    }
  },
  computed: {
    ...mapGetters(['activeType', 'activeId'])
  }

}
</script>



// WEBPACK FOOTER //
// src/components/CardFormatting/StatsRow.vue